import { Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { CloseDialog } from 'src/app/general/services/dialog.service';
import { Consumer } from 'src/app/general/interfaces/functions';
import { AdditionalTaxEditorDialogData } from '../interfaces';
import { AdditionalTaxEditorDialogComponent } from './additional-tax-editor-dialog.component';

// ----------------------------------------------------------------------------
// Usage Example

// Template:

// TS:

// public updateAdditionalTax(tax: proto.waiternow.common.TaxesProto.TaxProto): void {
//   const inputDialogData: AdditionalTaxEditorDialogData = {
//     nameEn: Formatter.getText(tax.name, proto.waiternow.common.Language.ENGLISH),
//     nameEs: Formatter.getText(tax.name, proto.waiternow.common.Language.SPANISH),
//     rate: tax.rate.value
//   }
//   this.additionalTaxEditorDialogService.openEditor(
//     inputDialogData,
//     /* onUpdate */ outputDialogData => {
//       // Updates values in tax. If the rate is removed, delete the tax.
//     }
//   );
// }

// ----------------------------------------------------------------------------

@Injectable({
  providedIn: 'root',
})
export class AdditionalTaxEditorDialogService {

  constructor(private dialog: MatDialog) { }

  public openEditor(inputDialogData: AdditionalTaxEditorDialogData, onUpdate: Consumer<AdditionalTaxEditorDialogData>) : CloseDialog {
    const dialogRef = this.dialog.open(AdditionalTaxEditorDialogComponent, {
      data: inputDialogData,
      autoFocus: true,
      hasBackdrop: true,
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe(outputDialogData => {
      if (outputDialogData) {
        onUpdate(outputDialogData);
      }
    });

    return () => dialogRef.close();
  }
}
